import React from 'react';

/**
 * Component in charge to display a location.
 * @param {GeocodingResult} data - A geocoding result object that contains the location infos.
 */
const LocationItem = ({ data }) => {
   return (
      <div className="location__item">{ data.placeName }</div>
   );
}

export default LocationItem;
